module.exports = __webpack_public_path__ + "pc/img/career-swiper02.77faf439.webp";